<template>
  <panel title="订单跟踪" class="mgb10">
    <el-row :gutter="10">
      <el-col :span="12">
        <div class="subtitle">近交期</div>
        <vxe-table
          :data="nears"
          border="inner"
          size="small"
          :loading="loading"
          class="border-inner-top"
          :show-header="false"
          auto-resize
          highlight-hover-row
          :scroll-y="{ enabled: false }"
        >
          <vxe-table-column field="range" title="时间"></vxe-table-column>
          <vxe-table-column field="quantity" title="数量" width="60px">
            <template v-slot="{ row }">
              <router-link
                :to="{
                  name: 'omsBargains',
                  query: { initFilter: [row.key] },
                }"
              >
                {{ row.quantity }}
              </router-link>
            </template>
          </vxe-table-column>
        </vxe-table>
      </el-col>
      <el-col :span="12">
        <div class="subtitle">过交期</div>
        <vxe-table
          :data="passes"
          border="inner"
          size="small"
          :loading="loading"
          class="border-inner-top"
          :show-header="false"
          auto-resize
          highlight-hover-row
          :scroll-y="{ enabled: false }"
        >
          <vxe-table-column field="range" title="时间"></vxe-table-column>
          <vxe-table-column field="quantity" title="数量" width="60px">
            <template v-slot="{ row }">
              <router-link
                :to="{
                  name: 'omsBargains',
                  query: { initFilter: row.key },
                }"
                >{{ row.quantity }}</router-link
              >
            </template>
          </vxe-table-column>
        </vxe-table>
      </el-col>
    </el-row>
  </panel>
</template>
<script>
import axios from "axios";
import Order from "@/api/order.js";
export default {
  data() {
    return {
      loading: false,
      nears: [],
      passes: [],
    };
  },
  created() {
    const self = this;
    axios
      .all([Order.nearQtys(Order.nearRange), Order.passQtys(Order.passRange)])
      .then(function (res) {
        const ons = res[0].data;
        Order.nearRange.forEach(function (nr, idx) {
          ons[idx] = { range: nr.label, quantity: ons[idx], key: nr.key };
        });
        self.nears = ons;
        const ops = res[1].data;
        Order.passRange.forEach(function (pr, idx) {
          ops[idx] = { range: pr.label, quantity: ops[idx], key: pr.key };
        });
        self.passes = ops;
      });
  },
};
</script>

<style scoped>
.subtitle {
  font-size: 13px;
  color: #606266;
  margin-bottom: 10px;
  font-weight: bold;
}
</style>